<template>
  <div class="app">
    <AddToHomeScreen v-if="!isAppAddedToHomeScreen && isIOS" />

    <main class="main">
      <router-view />
    </main>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import FireBase from "@/models/fire";
import Auth from "@/controller/auth";
import AddToHomeScreen from "@/components/a2hs/AddToHomeScreen.vue";
import TheFooter from "@/components/footer/TheFooter.vue";

FireBase.init();

const isAppAddedToHomeScreen = window.matchMedia("(display-mode: standalone)")
  .matches;

const isIOS: boolean =
  [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  (navigator.userAgent.includes("Mac") && !!document.ontouchend);

@Options({
  components: {
    AddToHomeScreen,
    TheFooter
  }
})
export default class App extends Vue {
  isAppAddedToHomeScreen: boolean = isAppAddedToHomeScreen;
  isIOS = isIOS;

  get isLoginRegisterPage(): boolean {
    const routeName = this.$route.name;
    return routeName === "Login" || routeName === "Register";
  }

  created() {
    Auth.getFirebaseAuth().onAuthStateChanged((user) => {
      if (user) {
        Auth.setIsAuth(user.uid);
      } else {
        Auth.clearAuth();
        if (!this.isLoginRegisterPage) {
          this.$router.push({ name: "Login" });
        }
      }
    });
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400&display=swap");

:root {
  font-size: 16px;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

button {
  cursor: pointer;
}

html,
body {
  height: 100%;
}

#app {
  height: 100%;
  color: $primary-color;
  text-align: center;
  font-family: "Montserrat", sans-serif;
}

.app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.main {
  width: 100%;
  height: 100%;
}
</style>
